var App = App || {};

App.WidgetSolutions = (function ($) {
    'use strict';

    function Init(widget) {
        Animate(widget);
        widget.ZagHorizontalOverflow();
    }

    function Animate(widget) {
        const animate = widget.find(".widget-solutions__goals");
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".reusable-solution", type: "animate__fadeInUp", stagger: 200 }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);